module.exports = __webpack_public_path__ + "img/qj-qrcode.b6040417.jpg";